import React, { useState, useEffect, useCallback } from 'react';

const Carousel = ({ slides }) => {
  const [current, setCurrent] = useState(0);
  const [imageSrc, setImageSrc] = useState(null);

  const nextSlide = useCallback(() => {
    setCurrent(prevCurrent => 
      prevCurrent === slides.length - 1 ? 0 : prevCurrent + 1
    );
  }, [slides.length]);

  useEffect(() => {
    const timer = setTimeout(nextSlide, 8000);
    return () => clearTimeout(timer);
  }, [current, nextSlide]);

  useEffect(() => {
    const currentSlide = slides[current];
    if (currentSlide) {
      setImageSrc(currentSlide.image);
    }
  }, [current, slides]);

  return (
    <div className="carousel">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={index === current ? 'slide active' : 'slide'}
        >
            <>
              <img src={slide.image === imageSrc ? imageSrc : ''} alt={slide.title} className="carousel-image-bg"/>
              <div className="carousel-content">
                <h1>{slide.title}</h1>
                <p>{slide.text}</p>
                {/* <button>Ver Coleção</button> */}
              </div>
            </>
          )
        </div>
      ))}
    </div>
  );
};

export default Carousel;